import { useTiktokUserHashtagsQuery } from '@anytag/graphql';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { useTiktokTagsAnalyticsFilter } from '@anytag/shared-organisms';
import { Template } from './template';

export const TiktokHashtagsAnalytics = () => {
  useUpdateDocumentTitle({
    title: 'appHeader.Tiktok Hashtag Analytics',
    appHeader: 'appHeader.Tiktok Hashtag Analytics'
  });
  const { filter, setFilter, countryId } = useTiktokTagsAnalyticsFilter();
  const { data, loading, called } = useTiktokUserHashtagsQuery({
    variables: { countryId },
    fetchPolicy: 'cache-and-network',
    onCompleted: ({ tiktokUserHashtags }) => {
      const isValidHashtag = tiktokUserHashtags?.hashtags?.findIndex((hashtag) => hashtag.id === filter.tagId) !== -1;

      if (!filter.tagId || !isValidHashtag) {
        setFilter({ tagId: tiktokUserHashtags?.hashtags?.at(0)?.id || '' }, { replace: true });
      }
    }
  });

  return (
    <RenderDataWithFallback loading={loading && !called} hasNoData={!filter.date}>
      <Template hashtags={data?.tiktokUserHashtags.hashtags || []} />
    </RenderDataWithFallback>
  );
};
